<template>
  <div id="buyerProfileSettingPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-gear fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">تنظیمات پروفایل کاربری</span>
                </div>
              </div>
            </div>
            <v-form ref="form" class="row">
              <div class="col-8 col-md-7 text-left ">

                <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                       name="ImageFileUrl" type="file"
                       @change="attachmentSelected">
                <v-avatar size="100">
                  <img v-if="selectedImage !== null && selectedImage !== 'null'" :src="selectedImage" alt="تصویر کاربر">
                  <i v-else class="fas fa-circle-user user-no-pic"></i>
                </v-avatar>
              </div>
              <div class="col-4 pr-0 ">
                <v-btn icon @click="$refs.inputUpload.click()"><i class="fa-solid fa-pen-to-square fa-2xl"></i></v-btn>
                <div class="pr-3">عکس مربع باشد</div>
              </div>شعار
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">نام *</div>
                <v-text-field v-model="firstName" :rules="MandatoryFieldRule" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">نام خانوادگی *</div>
                <v-text-field v-model="lastName" :rules="MandatoryFieldRule" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">شماره همراه(نام کاربری) *</div>
                <v-text-field v-model=" phoneNumber" :rules="phoneNumberRules" dense flat readonly solo>
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">کدملی</div>
                <v-text-field v-model="nationalCode" :rules="nationalCodeRules" dense flat solo type="number">
                </v-text-field>
              </div>
              <div class="col-12 py-1">
                <div class="mr-2 mb-2">پست الکترونیکی</div>
                <v-text-field v-model="email" :rules="emailRules" dense flat solo>
                </v-text-field>
              </div>
              <div class="col-12">
                <v-btn block color="primary" @click="editProfile">
                  تایید
                </v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText">

      </div>
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "SellerProfileSetting",
  metaInfo: {
    title: 'ایوان خانه- تنظیمات پروفایل',
  },
  components: {BackBar},
  data: () => ({
    showResult: false,
    showLoaderDialog: false,
    resultText: '',
    lastName: '',
    firstName: '',
    MandatoryFieldRule: [v => !!v || 'فیلد اجباری'],
    selectedImageFilePath: null,
    selectedImage: null,
    emailRules: [
      v => !!v || 'ایمیل اجباری است',
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (pattern.test(v) || !v) || 'ایمیل نامعتبر'
      },
    ],
    nationalCodeRules: [
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    nationalCode: '',
    email: '',
    phoneNumberRules: [
      v => !!v || 'شماره موبایل اجباری است',
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    phoneNumber: null,
    id: null,
    userName: null,
    password: null,
    isActive: null,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    attachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.selectedImage = null;
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImage = fr.result
          this.selectedImageFilePath = files[0] // this is an image file that can be sent to server...
        })
      }
    },
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Individual/_IndividualProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)
            this.firstName = json.Name === null ? '' : json.Name
            this.lastName = json.Family === null ? '' : json.Family
            this.phoneNumber = json.PhoneNumber
            this.nationalCode = json.NationalCode === null ? '' : json.NationalCode
            this.email = json.Email === null ? '' : json.Email
            this.selectedImage = json.FileUrl;
            this.id = json.ID
            this.userName = json.UserName
            this.password = json.Password
            this.isActive = json.IsActive
          })
          .catch(error => console.log('error', error));
    },
    editProfile() {
      this.$refs.form.validate()

      if (this.$refs.form.validate()) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let formdata = new FormData();
        formdata.append("ID", this.id);
        formdata.append("UserName", this.userName);
        formdata.append("Email", this.email);
        formdata.append("Password", this.password);
        formdata.append("ConfirmPassword", this.password);
        formdata.append("Name", this.firstName);
        formdata.append("Family", this.lastName);
        formdata.append("NationalCode", this.nationalCode);
        formdata.append("TypeRole", '3');
        // if (this.selectedImage === null) {
        //   formdata.append("ImageFileUrl", this.selectedImageFilePath);
        // } else {
          formdata.append("FileUrl", this.selectedImage);
        // }
        formdata.append("PhoneNumber", this.phoneNumber);
        formdata.append("IsActive", this.isActive);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "VendorPanel/Individual/_IndividualProfile", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              this.showLoaderDialog = false
              if (resStatus === 200) {
                let json = JSON.parse(result)
                this.resultText = json.Message
                this.getData()

              } else {
                this.resultText = result

              }
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      }
    }
  }
}
</script>

<style scoped>

</style>
